<div *ngIf="this.showFirstStep" fxFill fxLayout="column" fxLayoutAlign="start center">
  <!-- HEADER -->
  <app-header-noauth
    [onfido]="true"
    class="appHeader appHeader--sticky appHeader--noauth"
    [hideLanguage]="true"
  ></app-header-noauth>
  <!-- BODY -->
  <div class="wrapper wrapper--noauth" fxLayoutAlign="center center" fxFlex="100%">
    <div fxFlex="100" class="wrapper__content">
      <mat-card fxFlex="100">
        <div class="content">
          <ng-container *ngIf="validSms == 'yes' && process == stateVideoselfingEnum.NOTINIT">
            <div class="header">
              <h1 translate>videoselfing.landing.header.title</h1>
              <h2 translate>videoselfing.landing.header.subtitle</h2>
            </div>
            <div class="content">
              <div class="steps-container">
                <div class="icon-container">
                  <img src="assets/img/person_icon.svg" alt="person icon" />
                </div>

                <div class="steps-text">
                  <h3 class="text-header" translate>videoselfing.landing.steps.video.title</h3>
                  <div translate>
                    videoselfing.landing.steps.video.requirements
                    <ul>
                      <li class="custom-bullet" translate>videoselfing.landing.steps.video.requirements.first</li>
                      <li class="custom-bullet" translate>videoselfing.landing.steps.video.requirements.second</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="steps-container" *ngIf="participantsNumber > 1">
                <div class="icon-container">
                  <img src="assets/img/clock_icon.svg" alt="clock icon" />
                </div>
                <div class="steps-text">
                  <h3 class="text-header" translate>videoselfing.landing.steps.interveners.title</h3>
                  <p translate>videoselfing.landing.steps.interveners.text</p>
                </div>
              </div>

              <div class="steps-container">
                <div class="icon-container">
                  <img src="assets/img/edit_icon.svg" alt="edit icon" />
                </div>
                <div class="steps-text">
                  <h3 class="text-header" translate>videoselfing.landing.steps.sign.title</h3>
                  <p translate>videoselfing.landing.steps.sign.text</p>
                </div>
              </div>

              <div class="steps-container">
                <div class="icon-container">
                  <img src="assets/img/check_icon.svg" alt="check icon" />
                </div>
                <div class="steps-text">
                  <h3 class="text-header" translate>videoselfing.landing.steps.confirmation.title</h3>
                  <p translate>videoselfing.landing.steps.confirmation.text</p>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button class="landing-button" id="searchBtnId" mat-flat-button color="accent" (click)="openConsent()">
                {{ 'request.matStepperNext' | translate }}
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="validSms == 'no' && process == stateVideoselfingEnum.NOTINIT">
            <h1 class="noValidSms" translate>videoselfing.error.expiration</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.APPROVED">
            <h1 class="noValidSms" translate>videoselfing.error.complete</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.KO">
            <h1 class="noValidSms" translate>videoselfing.error.process</h1>
          </ng-container>
          <ng-container *ngIf="isError == true">
            <h1 class="noValidSms" translate>videoselfing.error.noexists</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.EXPIRED">
            <h1 class="noValidSms" translate>videoselfing.error.expiration</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.REVIEW">
            <h1 class="noValidSms" translate>videoselfing.error.revision</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.DECLINED">
            <h1 class="noValidSms" translate>videoselfing.error.declined</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.PROCESSING">
            <h1 class="noValidSms" translate>videoselfing.error.processing</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.ABANDONED">
            <h1 class="noValidSms" translate>videoselfing.error.abandoned</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.ERROR">
            <h1 class="noValidSms" translate>videoselfing.error.error</h1>
          </ng-container>
          <ng-container *ngIf="process == stateVideoselfingEnum.INPROCESS">
            <h2 translate>videoselfing.finish.title</h2>
            <p translate>videoselfing.finish.subtitle</p>
          </ng-container>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<app-consent-dialog (isCancel)="isShowFirstStep($event)" [show]="!this.showFirstStep" [uuId]="this.uuId">
</app-consent-dialog>
